<template>
  <div>
    <div
      class="modal"
      tabindex="-1"
      data-backdrop="static"
      id="modal_please_wait"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="p-5">
            <span>Please wait...</span>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" tabindex="-1" id="exampleModal">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Edit Info</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-3">
                <h6 class="">General Info</h6>
              </div>
              <div class="col-9">
                <div class="form-group">
                  <label for="vessel_name">Ship's Name</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    id="vessel_name"
                    v-model="tempVesselInformation.name"
                  />
                </div>
                <div class="form-group">
                  <label for="vessel_name">Ship's Code</label>
                  <input
                      type="text"
                      class="form-control form-control-sm"
                      id="vessel_name"
                      v-model="tempVesselInformation.code"
                  />
                </div>
                <div class="form-group">
                  <label for="flag">Nationality</label>
                  <select
                    class="form-control form-control-sm"
                    id="flag"
                    v-model="tempVesselInformation.flag_id"
                  >
                    <option value="''">-- Select Nationality --</option>
                    <option
                      v-for="countryKey in countryKeys"
                      :key="countryKey.id"
                      :value="countryKey.id"
                      >{{ countryKey.natl }}</option
                    >
                  </select>
                </div>
                <div class="form-group">
                  <label for="vessel_type">Ship's Type</label>
                  <select
                    class="form-control form-control-sm"
                    id="vessel_type"
                    v-model="tempVesselInformation.vessel_type_id"
                  >
                    <option value="''">-- Select Vessel Type --</option>
                    <option
                      v-for="vesselTypeKey in vesselTypeKeys"
                      :key="vesselTypeKey.id"
                      :value="vesselTypeKey.id"
                      >{{ vesselTypeKey.name }}</option
                    >
                  </select>
                </div>
                <div class="form-group">
                  <label for="vessel_name">Call Sign</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    id="vessel_name"
                    v-model="tempVesselInformation.alias"
                  />
                </div>
                <div class="form-group">
                  <label for="registry_port">Port of Registry</label>
                  <select
                    class="form-control form-control-sm"
                    id="registry_port"
                    v-model="tempVesselInformation.port_id"
                  >
                    <option value="''">-- Select Registry Port --</option>
                    <option
                      v-for="portKey in portKeys"
                      :key="portKey.id"
                      :value="portKey.id"
                      >{{ portKey.name }}</option
                    >
                  </select>
                </div>
                <div class="form-group">
                  <label for="imo_no">Official No.</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    name="imo_no"
                    id="imo_no"
                    v-model="tempVesselInformation.official_no"
                  />
                </div>
                <div class="form-group">
                  <label for="imo_no">IMO Number.</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    name="imo_no"
                    id="imo_no"
                    v-model="tempVesselInformation.imo_no"
                  />
                </div>
                <div class="form-group">
                  <label for="imo_company_no">IMO Company Number.</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    name="imo_company_no"
                    id="imo_company_no"
                    v-model="tempVesselInformation.imo_company_no"
                  />
                </div>
                <div class="form-group">
                  <label for="cba_type">MMSI</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    name="cba_type"
                    id="cba_type"
                    v-model="tempVesselInformation.mmsi"
                  />
                </div>
                <div class="form-group">
                  <label for="classification">Classification</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    name="classification"
                    id="classification"
                    v-model="tempVesselInformation.classification"
                  />
                </div>
                <div class="form-group">
                  <label for="hull_no">Hull No.</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    name="hull_no"
                    id="hull_no"
                    v-model="tempVesselInformation.hull_no"
                  />
                </div>
                <div class="form-group">
                  <label for="pana_id">Pana I.D.</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    name="pana_id"
                    id="pana_id"
                    v-model="tempVesselInformation.pana_id"
                  />
                </div>
                <div class="form-group">
                  <label for="suez_id">Suez I.D.</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    name="suez_id"
                    id="suez_id"
                    v-model="tempVesselInformation.suez_id"
                  />
                </div>
                <div class="form-group">
                  <label for="vessel_image">Vessel Image</label>
                  <input
                    type="file"
                    class="form-control form-control-sm"
                    name="vessel_image"
                    id="vessel_image"
                    accept="image/jpeg"
                  />
                </div>
              </div>
            </div>
            <hr />

            <div class="row">
              <div class="col-3 font-weight-bold">
                <h6>Assigned Manning</h6>
              </div>
              <div class="col-9">
                <div class="form-group">
                  <div v-for="manningKey in manningKeys" :key="manningKey.id">
                    <div class="form-check d-block">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :value="manningKey"
                        :id="'manningKey' + manningKey.id"
                        v-model="tempVesselInformation.mannings"
                      />
                      <label
                        class="form-check-label w-100"
                        :for="'manningKey' + manningKey.id"
                      >
                        {{ manningKey.alias }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr />

            <div class="row">
              <div class="col-3 font-weight-bold">
                <h6>ECDIS Type</h6>
              </div>
              <div class="col-9">
                <div class="form-group">
                  <div v-for="ecdisKey in ecdisKeys" :key="ecdisKey.id">
                    <div class="form-check d-block">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :value="ecdisKey.id"
                        v-model="vesselEcdis"
                        :id="'ecdisKey' + ecdisKey.id"
                      />
                      <label
                        class="form-check-label w-100"
                        :for="'ecdisKey' + ecdisKey.id"
                      >
                        {{ ecdisKey.name }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr />
            <div class="row">
              <div class="col-3">
                <h6 class="">Management</h6>
              </div>
              <div class="col-9">
                <div class="form-group">
                  <label for="owner">Owner</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    id="owner"
                    v-model="tempVesselInformation.owner"
                  />
                </div>
                <div class="form-group">
                  <label for="owner">Owner Address</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    id="owner"
                    v-model="tempVesselInformation.owner_address"
                  />
                </div>
                <div class="form-group">
                  <label for="operator">Operator</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    id="operator"
                    v-model="tempVesselInformation.operator"
                  />
                </div>
                <div class="form-group">
                  <label for="operator_address">Operator Address</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    id="operator_address"
                    v-model="tempVesselInformation.operator_address"
                  />
                </div>
                <div class="form-group">
                  <label for="management">Management</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    name="management"
                    id="management"
                    v-model="tempVesselInformation.management"
                  />
                </div>
                <div class="form-group">
                  <label for="management_address">Management Address</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    name="management_address"
                    id="management_address"
                    v-model="tempVesselInformation.management_address"
                  />
                </div>
                <div class="form-group">
                  <label for="charterer">Charterer</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    name="charterer"
                    id="charterer"
                    v-model="tempVesselInformation.charterer"
                  />
                </div>
                <div class="form-group">
                  <label for="pandi_club">P&I Club</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    name="pandi_club"
                    id="pandi_club"
                    v-model="tempVesselInformation.pandi_club"
                  />
                </div>
                <div class="form-group">
                  <label for="builder">Builder</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    name="builder"
                    id="builder"
                    v-model="tempVesselInformation.builder"
                  />
                </div>
                <div class="form-group">
                  <label for="place_built">Place Built</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    name="place_built"
                    id="place_built"
                    v-model="tempVesselInformation.place_built"
                  />
                </div>
                <div class="form-group">
                  <label for="keel_laid">Keel Laid</label>
                  <input
                    type="date"
                    class="form-control form-control-sm"
                    name="keel_laid"
                    id="keel_laid"
                    v-model="tempVesselInformation.keel_laid"
                  />
                </div>
                <div class="form-group">
                  <label for="launched_date">Launched Date</label>
                  <input
                    type="date"
                    class="form-control form-control-sm"
                    name="launched_date"
                    id="launched_date"
                    v-model="tempVesselInformation.launched_date"
                  />
                </div>
                <div class="form-group">
                  <label for="delivery_date">Delivery Date</label>
                  <input
                    type="date"
                    class="form-control form-control-sm"
                    name="delivery_date"
                    id="delivery_date"
                    v-model="tempVesselInformation.delivery_date"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal"
              id="cancel_edit"
            >
              Cancel
            </button>
            <button type="button" class="btn btn-primary" @click="updateVessel">
              Save changes
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      tabindex="-1"
      id="upload_new_doc"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ modalVesselDocUploadToggle.title }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              id="close_upload_modal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div>
              <div v-if="isPrincipal || isSystemAdmin" class="form-group row">
                <label for="inputEmail3" class="col-1 col-form-label"
                  >File</label
                >
                <div class="col-sm-8">
                  <input
                    id="doc-file"
                    type="file"
                    required
                    accept="application/pdf"
                    class="form-control form-control-xs"
                    @change="updateDocFrame"
                  />
                </div>
                <div class="col-2">
                  <button
                    class="btn btn-primary btn-sm btn-xs"
                    @click="uploadVesselDoc"
                  >
                    <span class="fa fa-save"></span>
                    Save
                  </button>
                </div>
              </div>
            </div>
            <div>
              <div
                v-show="isFileTooLarge"
                class="text-center alert alert-secondary font-weight-bolder"
              >
                File too Large
              </div>
              <div
                v-show="!hasDocUploaded"
                class="text-center alert alert-secondary font-weight-bolder"
              >
                No file uploaded
              </div>
              <iframe
                :src="vesselDoc"
                frameborder="0"
                height="500"
                width="720"
                id="doc-frame"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-between">
      <span class="font-weight-bold">General Overview</span>
      <div class="d-flex">
        <template v-if="isSystemAdmin">
          <button
            type="submit"
            class="btn btn-sm btn-xs btn-warning font-weight-bold"
            data-toggle="modal"
            data-target="#exampleModal"
          >
            <span class="fas fa-user-edit"></span>
            Edit Info
          </button>
        </template>

        <button
          type="button"
          class="ml-2 btn btn-sm btn-xs btn-outline-secondary font-weight-bold"
          data-toggle="modal"
          data-target="#upload_new_doc"
          @click="toggleVesselDocModal(vesselParticularDocType)"
        >
          <span class="fas fa-file-alt"></span>
          Ship's Particular Doc
        </button>
        <button
          type="button"
          class="ml-2 btn btn-sm btn-xs btn-outline-secondary font-weight-bold"
          data-toggle="modal"
          data-target="#upload_new_doc"
          @click="toggleVesselDocModal(vesselMsmcDocType)"
        >
          <span class="fas fa-file-alt"></span>
          MSMC Doc
        </button>
        <button
          type="button"
          class="ml-2 btn btn-sm btn-xs btn-outline-secondary font-weight-bold"
          data-toggle="modal"
          data-target="#upload_new_doc"
          @click="toggleVesselDocModal(vesselNationalDocType)"
        >
          <span class="fas fa-file-alt"></span>
          National Certificate
        </button>
        <button
          type="button"
          class="ml-2 btn btn-sm btn-xs btn-outline-secondary font-weight-bold"
          data-toggle="modal"
          data-target="#upload_new_doc"
          @click="toggleVesselDocModal(vesselUsmcDocType)"
        >
          <span class="fas fa-file-alt"></span>
          USMC Doc
        </button>
      </div>
    </div>
    <div class="row text-small mt-3">
      <div class="col-sm-7 mx-auto text-center">
        <div class="row text-small m-3">
          <div class="col col-md-12">
            <img
              v-if="vesselImage"
              class="border vessel-pic float-left"
              alt="Vessel Image"
              :src="vesselImage"
            />
            <img
              v-else
              class="border vessel-pic float-left"
              alt="Vessel Image"
              :src="require(`@/assets/crew.png`)"
            />
          </div>
          <div class="col col-md-12">
            <hr />
          </div>
          <div class="col-md-4">
            <h6 class="font-weight-bolder text-left">Assigned Manning</h6>
            <div class="form-group row">
              <div
                class="col-sm-12 offset-1 text-left"
                v-for="manningKey in manningKeys"
                :key="manningKey.id"
              >
                <div class="form-check d-block">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :value="manningKey.id"
                    :id="'manningKey' + manningKey.id"
                    :checked="isManninChecked(manningKey.id)"
                    disabled
                  />
                  <label
                    class="form-check-label w-100"
                    :for="'manningKey' + manningKey.id"
                  >
                    {{ manningKey.alias }}
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-8">
            <h6 class="font-weight-bolder text-left">ECDIS Type</h6>
            <div class="form-group row">
              <div
                class="col-sm-12 offset-1 text-left mb-2"
                v-for="ecdisKey in ecdisKeys"
                :key="ecdisKey.id"
              >
                <!-- <div class="form-check d-block">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :value="ecdisKey.id"
                    :id="'ecdisKey' + ecdisKey.id"
                    :checked = vesselEcdis[ecdisKey.id]
                    readonly
                  />
                  <label
                    :for="'ecdisKey' + ecdisKey.id"
                    class="form-check-label w-100"
                  >
                    {{ ecdisKey.name + " " + ecdisKey.id }}
                  </label>
                </div> -->
                <div class="d-bloc">
                    <svg v-if="isFound(ecdisKey.id)" aria-hidden="true" focusable="false" data-prefix="far" data-icon="check-square" class="text-primary svg-inline--fa fa-check-square fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm0 400H48V80h352v352zm-35.864-241.724L191.547 361.48c-4.705 4.667-12.303 4.637-16.97-.068l-90.781-91.516c-4.667-4.705-4.637-12.303.069-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l59.792 60.277 141.352-140.216c4.705-4.667 12.303-4.637 16.97.068l22.536 22.718c4.667 4.706 4.637 12.304-.068 16.971z"></path></svg>
                    <svg v-else aria-hidden="true" focusable="false" data-prefix="far" data-icon="square" class="text-primary svg-inline--fa fa-square fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"></path></svg>
                    <span class="ml-2">{{ ecdisKey.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-5">
        <table class="table table-sm" id="genInfoTable" v-if="vesselInfo.id">
          <tbody>
            <tr :class="{ 'has-error': vesselInformationErrors.name }">
              <th scope="row" class="align-middle">
                <label
                  class="font-weight-bolder text-left form-label-xs"
                  for="vessel-name"
                >
                  Ship's Name:
                </label>
              </th>
              <td class="align-middle text-uppercase">
                <span>{{ vesselInformation.name }}</span>
              </td>
            </tr>
            <tr :class="{ 'has-error': vesselInformationErrors.name }">
              <th scope="row" class="align-middle">
                <label
                    class="font-weight-bolder text-left form-label-xs"
                    for="vessel-name"
                >
                  Ship's Code:
                </label>
              </th>
              <td class="align-middle text-uppercase">
                <span>{{ vesselInformation.code }}</span>
              </td>
            </tr>


            <tr :class="{ 'has-error': vesselInformationErrors.country_id }">
              <th scope="row" class="align-middle">
                <label
                  class="font-weight-bolder text-left form-label-xs"
                  for="flag"
                >
                  Nationality:
                </label>
              </th>
              <td class="align-middle text-uppercase">
                <span>{{
                  vesselInformation.flag ? vesselInformation.flag.natl : ""
                }}</span>
              </td>
            </tr>

            <tr
              :class="{ 'has-error': vesselInformationErrors.vessel_type_id }"
            >
              <th scope="row" class="align-middle">
                <label
                  class="font-weight-bolder text-left form-label-xs"
                  for="vessel-type"
                >
                  Ship's Type:
                </label>
              </th>
              <td class="align-middle text-uppercase">
                <span>{{
                  vesselInformation.vessel_type
                    ? vesselInformation.vessel_type.name
                    : ""
                }}</span>
              </td>
            </tr>

            <tr :class="{ 'has-error': vesselInformationErrors.alias }">
              <th scope="row" class="align-middle">
                <label
                  class="font-weight-bolder text-left form-label-xs"
                  for="vessel-group"
                >
                  Call Sign:
                </label>
              </th>
              <td class="align-middle text-uppercase">
                <span>{{ vesselInformation.alias }}</span>
              </td>
            </tr>

            <tr :class="{ 'has-error': vesselInformationErrors.port_id }">
              <th scope="row" class="align-middle">
                <label
                  class="font-weight-bolder text-left form-label-xs"
                  for="port"
                >
                  Port of Registry:
                </label>
              </th>
              <td class="align-middle text-uppercase">
                <span v-if="vesselInformation.port">{{
                  vesselInformation.port ? vesselInformation.port.name : ""
                }}</span>

                <span  class="text-danger" v-else>
                  Port not found
                </span>

              </td>
            </tr>

            <tr :class="{ 'has-error': vesselInformationErrors.port_id }">
              <th scope="row" class="align-middle">
                <label
                  class="font-weight-bolder text-left form-label-xs"
                  for="port"
                >
                  Official No.:
                </label>
              </th>
              <td class="align-middle text-uppercase">
                <span>{{ vesselInformation.official_no }}</span>
              </td>
            </tr>

            <tr :class="{ 'has-error': vesselInformationErrors.imo }">
              <th scope="row" class="align-middle text-uppercase">
                <label
                  class="font-weight-bolder text-left form-label-xs"
                  for="imo"
                >
                  IMO Number:
                </label>
              </th>
              <td class="align-middle text-uppercase">
                <span>{{ vesselInformation.imo_no }}</span>
              </td>
            </tr>

            <tr
              :class="{ 'has-error': vesselInformationErrors.imo_company_no }"
            >
              <th scope="row" class="align-middle text-uppercase">
                <label
                  class="font-weight-bolder text-left form-label-xs"
                  for="imo"
                >
                  IMO Company Number:
                </label>
              </th>
              <td class="align-middle">
                <span>{{ vesselInformation.imo_company_no }}</span>
              </td>
            </tr>

            <tr :class="{ 'has-error': vesselInformationErrors.mmsi }">
              <th scope="row" class="align-middle text-uppercase">
                <label
                  class="font-weight-bolder text-left form-label-xs"
                  for="official"
                >
                  MMSI:
                </label>
              </th>
              <td class="align-middle text-uppercase">
                <span>{{ vesselInformation.mmsi }}</span>
              </td>
            </tr>

            <tr
              :class="{ 'has-error': vesselInformationErrors.classification }"
            >
              <th scope="row" class="align-middle text-uppercase">
                <label
                  class="font-weight-bolder text-left form-label-xs"
                  for="classification"
                >
                  Classification:
                </label>
              </th>
              <td class="align-middle text-uppercase">
                <span>{{ vesselInformation.classification }}</span>
              </td>
            </tr>

            <tr :class="{ 'has-error': vesselInformationErrors.hull_no }">
              <th scope="row" class="align-middle text-uppercase">
                <label
                  class="font-weight-bolder text-left form-label-xs"
                  for="hull_no"
                >
                  Hull No.
                </label>
              </th>
              <td class="align-middle text-uppercase">
                <span>{{ vesselInformation.hull_no }}</span>
              </td>
            </tr>

            <tr :class="{ 'has-error': vesselInformationErrors.cba_type }">
              <th scope="row" class="align-middle text-uppercase">
                <label
                  class="font-weight-bolder text-left form-label-xs"
                  for="cba_type"
                >
                  Pana I.D.
                </label>
              </th>
              <td class="align-middle text-uppercase">
                <span>{{ vesselInformation.pana_id }}</span>
              </td>
            </tr>

            <tr :class="{ 'has-error': vesselInformationErrors.cba_type }">
              <th scope="row" class="align-middle text-uppercase">
                <label
                  class="font-weight-bolder text-left form-label-xs"
                  for="cba_type"
                >
                  Suez I.D.
                </label>
              </th>
              <td class="align-middle text-uppercase">
                <span>{{ vesselInformation.suez_id }}</span>
              </td>
            </tr>

            <tr :class="{ 'has-error': vesselInformationErrors.active }">
              <th scope="row" class="align-middle text-uppercase">
                <label
                  class="font-weight-bolder text-left form-label-xs"
                  for="active"
                >
                  Vessel Status:
                </label>
              </th>
              <td class="align-middle">
                <span>{{
                  vesselInformation.active ? "ACTIVE" : "INACTIVE"
                }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <hr />
    <div class="row text-small mt-3">
      <div class="col-7">
        <table class="table table-sm">
          <tbody>
            <tr>
              <td class="font-weight-bold w-50">Owner</td>
              <td class="w-50">{{ vesselInformation.owner }}</td>
            </tr>
            <tr>
              <td class="font-weight-bold w-50">Owner Address</td>
              <td class="w-50">{{ vesselInformation.owner_address }}</td>
            </tr>
            <tr>
              <td class="font-weight-bold w-50">Operator</td>
              <td class="w-50">{{ vesselInformation.operator }}</td>
            </tr>
            <tr>
              <td class="font-weight-bold w-50">Management</td>
              <td class="w-50">{{ vesselInformation.management }}</td>
            </tr>
            <tr>
              <td class="font-weight-bold w-50">Management Address</td>
              <td class="w-50">{{ vesselInformation.management_address }}</td>
            </tr>
            <tr>
              <td class="font-weight-bold w-50">Op Address</td>
              <td class="w-50">{{ vesselInformation.operator_address }}</td>
            </tr>
            <tr>
              <td class="font-weight-bold w-50">Charterer</td>
              <td class="w-50">{{ vesselInformation.charterer }}</td>
            </tr>
            <tr>
              <td class="font-weight-bold w-50">P&I Club</td>
              <td class="w-50">{{ vesselInformation.pandi_club }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-5">
        <table class="table table-sm">
          <tbody>
            <tr>
              <th class="font-weight-bold w-50">Builder</th>
              <td class="w-50">{{ vesselInformation.builder }}</td>
            </tr>
            <tr>
              <th class="font-weight-bold w-50">Place Built</th>
              <td class="w-50">{{ vesselInformation.place_built }}</td>
            </tr>
            <tr>
              <th class="font-weight-bold w-50">Keel Laid</th>
              <td class="w-50">
                {{ vesselInformation.keel_laid | moment("DD MMM YYYY") }}
              </td>
            </tr>
            <tr>
              <th class="font-weight-bold w-50">Launched Date</th>
              <!-- <td class="w-50">{{ vesselInformation.launched_date }}</td> -->
              <td class="w-50">
                {{ vesselInformation.launched_date | moment("DD MMM YYYY") }}
              </td>
            </tr>
            <tr>
              <th class="font-weight-bold w-50">Delivery Date</th>
              <!-- <td class="w-50">{{ vesselInformation.delivery_date }}</td> -->
              <td class="w-50">
                {{ vesselInformation.delivery_date | moment("DD MMM YYYY") }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { vueAppMixin } from "@/mixins/vueAppMixin";
import { gateMixin } from "@/mixins/gateMixin";
import { mapActions, mapGetters, mapState } from "vuex";
import { vesselMixin } from "@/mixins/vesselMixin";
const vesselParticularDocType = "vesselParticular";
const vesselMsmcDocType = "msmc";
const vesselNationalDocType = "vesselNationalDoc";
const vesselUsmcDocType = "vesselUsmc";

export default {
  name: "VesselGeneralInfo",
  mixins: [vueAppMixin, vesselMixin, gateMixin],

  data() {
    return {
      tempVesselInformation: {
        vessel_name: null,
        vessel_code: null,
        vessel_type_id: null,
        vessel_group_id: null,
        registry_port_id: null,
        flag_id: null,
        imo_no: null,
        official_no: null,
        insurance: null,
        japan_coastal: null,
        cba_type: null,
        poea_principal: null,
        mannings: [],
        vessel_ecdis: [],
        owner: null,
        owner_address: null,
        operator: null,
        operator_address: null,
        management: null,
        management_address: null,
        charterer: null,
        pandi_club: null,
        keel_laid: null,
        launched_date: null,
        delivery_date: null,
        classification: null,
        mmsi: null,
        pana_id: null,
        suez_id: null,
        imo_company_no: null,
      },
      vesselInformation: {},
      //   tempVesselInformationInformation: {},
      vesselInformationErrors: {},
      vesselImage:{},
      mannings: [],
      editable: false,
      vesselParticularDocType: vesselParticularDocType,
      vesselMsmcDocType: vesselMsmcDocType,
      vesselNationalDocType: vesselNationalDocType,
      vesselUsmcDocType: vesselUsmcDocType,
      modalVesselDocUploadToggle: {
        type: null,
        title: null,
      },
      isFileTooLarge: false,
      hasDocUploaded: false,
      vesselDoc: null,
      vesselEcdis: [],
    };
  },

  methods: {
    ...mapActions([
      "getVesselInfo",
      "getVesselTypeKeys",
      "getVesselGroupKeys",
      "getPortKeys",
      "getCountryKeys",
      "updateVesselInfo",
      "getManningKeys",
      "getEcdisKeys",
      "getVesselInfo",
      "getVesselImage",
    ]),
    async confirmUpdateVesselInfo() {
      if (this.editable) {
        if (await this.confirmUpdate()) {
          let params = this.vesselInformation;
          params["manningIds"] = this.mannings;
          let updatedVesselInfo = await this.updateVesselInfo(params);
          if (updatedVesselInfo) {
            if (updatedVesselInfo.errors) {
              this.vesselInformationErrors = updatedVesselInfo.errors;
            } else {
              this.vesselInformation = Object.assign({}, this.vesselInfo);
              this.tempVesselInformationInformation = Object.assign(
                {},
                this.vesselInfo
              );
              this.successAlert("Vessel Info Successfully Updated", "UPDATE");
              this.editable = false;
            }
          }
        }
      } else {
        this.vesselInformation = this.tempVesselInformationInformation;
        this.editable = true;
      }
    },
    async updateVessel() {
      let self = this;
      let formData = new FormData();
      let pleaseWait = Swal.fire({
        text: "Please wait...",
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: false,
      });
      let vesselImageInput = document.getElementById("vessel_image");

      if (vesselImageInput.files && vesselImageInput.files[0]) {
        formData.append("vessel_image", vesselImageInput.files[0]);
      }

      Object.keys(this.tempVesselInformation).forEach((key) => {
        if (key === "vessel_image") return;
        if (key === "mannings") {
          let mannings = this.tempVesselInformation["mannings"];
          for (let i = 0; i < mannings.length; i++) {
            formData.append("mannings[]", mannings[i].id);
          }
        } else if (key === "vessel_ecdis") {
          let vesselEcdis = this.tempVesselInformation["vessel_ecdis"];
        //   for (let i = 0; i < vesselEcdis.length; i++) {
        //     // params["vessel_ecdis"].push(vesselEcdis[i].id);
        //     formData.append("vessel_ecdis[]", vessel_ecdis[i].id);
        //   }
        
                for (let i = 0; i < self.vesselEcdis.length; i++) {
                    formData.append("vessel_ecdis[]", this.vesselEcdis[i]);
                }
        } else {
          //   params[key] = this.tempVesselInformation[key];
          if (!this.tempVesselInformation[key]) {
            formData.set(key, "");
            return;
          }

          formData.set(key, this.tempVesselInformation[key]);
        }
      });

      let updatedVesselInfo = await this.updateVesselInfo(formData);

      if (updatedVesselInfo) {
        if (updatedVesselInfo.errors) {
          this.vesselInformationErrors = updatedVesselInfo.errors;
        } else {
          this.getVesselInfo({ vesselId: this.tempVesselInformation.id }).then(
            async () => {
              this.vesselInformation = Object.assign({}, this.vesselInfo);
              this.tempVesselInformationInformation = Object.assign(
                  {},
                  this.vesselInfo
              );
              document.getElementById("cancel_edit").click();
              this.vesselInformation = Object.assign({}, this.vesselInfo);
              this.vesselImage = await this.getVesselImage(this.$route.params.id);
              pleaseWait.close();
              Swal.fire({
                title: "Edit Info",
                text: "Successfully Updated.",
                type: "success",
                timer: 2000,
              });
            }
          );
        }
      }
    },
    async initializeData() {
      let pleaseWait = Swal.fire({
        text: "Please wait...",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      let params = {
        vesselId: this.vesselId,
      };
      // await this.getVesselInfo(params);
      await this.getVesselTypeKeys();
      await this.getVesselGroupKeys();
      await this.getPortKeys();
      await this.getCountryKeys();
      await this.getManningKeys();
      await this.getEcdisKeys();
      await this.getVesselInfo({vesselId: this.$route.params.id});
      this.vesselImage=await this.getVesselImage(this.$route.params.id);
      this.vesselInformation = Object.assign({}, this.vesselInfo);
      this.tempVesselInformation = Object.assign({}, this.vesselInfo);

        this.vesselEcdis = Object.values(this.vesselInfo.vessel_ecdis).map(ecdis => {
            return ecdis.ecdis_id
        }, []) ?? [];

      this.tempVesselInformationInformation = Object.assign(
        {},
        this.vesselInfo
      );
      this.vesselInfo.mannings.forEach((manning) => {
        this.mannings.push(manning.id);
      });
      pleaseWait.close();
    },
    cancelEdit() {
      this.tempVesselInformationInformation = this.vesselInformation;
      this.vesselInformation = this.vesselInfo;
      this.mannings = [];
      this.vesselInfo.mannings.forEach((manning) => {
        this.mannings.push(manning.id);
      });
      // this.editable = false;
      //   this.tempVesselInformation = this.vesselInformation;
    },
    fetchVesselDoc(vesselId, docType) {
      return this.$store.dispatch("VesselDocModule/fetchVesselDoc", {
        vesselId,
        docType,
      });
    },
    uploadVesselDoc() {
      let self = this;
      let pleaseWait = Swal.fire({
        text: "Please wait...",
        showCancelButton: false,
        allowOutsideClick: false,
        showConfirmButton: false,
      });
      let formData = new FormData();
      let attachment = document.getElementById("doc-file");
      let file = attachment.files[0];

      formData.append("doc", file);
      formData.append("doc_type", this.modalVesselDocUploadToggle.docType);

      this.$store
        .dispatch("VesselDocModule/uploadVesselDoc", {
          vessel_id: this.vesselInfo.id,
          formData: formData,
        })
        .then(() => {
          self.clearDocFile();
          pleaseWait.close();
          document.getElementById("close_upload_modal").click();
        });
    },
    viewVesselParticularDoc() {
      if (!this.vesselDocParticular) return;

      fetch(`data:application/pdf;base64,${this.vesselDocParticular}`)
        .then((res) => res.blob())
        .then((blob) => {
          var url = window.URL.createObjectURL(blob);
          window.open(url);
        });
    },
    isManninChecked(manningKeyId) {
      if (!this.vesselInformation.mannings) return false;

      return this.vesselInformation.mannings.find(
        (manning) => manning.id == manningKeyId
      );
    },
    toggleVesselDocModal(docType) {
      let pleaseWait = Swal.fire({
        text: "Please wait...",
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: false,
      });

      this.clearDocFrame();
      if (this.isPrincipal || this.isSystemAdmin) {
        this.clearDocFile();
      }
      this.modalVesselDocUploadToggle.docType = docType;

      if (docType === this.vesselParticularDocType) {
        this.modalVesselDocUploadToggle.title = "Ship's Particular Doc";
      }

      if (docType === this.vesselMsmcDocType) {
        this.modalVesselDocUploadToggle.title = "MSMC Doc";
      }

      if (docType === this.vesselNationalDocType) {
        this.modalVesselDocUploadToggle.title = "National Certificate";
      }

      if (docType === this.vesselUsmcDocType) {
        this.modalVesselDocUploadToggle.title = "USMC Doc";
      }

      this.fetchVesselDoc(this.vesselInfo.id, docType)
        .then((res) => {
          this.vesselDoc = "";
          pleaseWait.close();

          if (res.data.pdf) {
            this.hasDocUploaded = true;
            this.vesselDoc = `data:application/pdf;base64,${res.data.pdf}`;
          } else {
            this.hasDocUploaded = false;
          }
        });
    },
    updateDocFrame() {
      let docInputFile = document.getElementById("doc-file");
      let docFrame = document.getElementById("doc-frame");

      this.isFileTooLarge = false;
      this.hasDocUploaded = true;

      if (docInputFile.files && docInputFile.files[0]) {
        if (docInputFile.files[0].size > 5000000) {
          docFrame.alt = "file too large";
          this.isFileTooLarge = true;
          this.clearDocFrame();
          return;
        }

        let reader = new FileReader();

        docFrame.alt = "";

        reader.onload = function(e) {
          docFrame.src = e.target.result;
        };
        reader.readAsDataURL(docInputFile.files[0]);
      } else {
        this.clearDocFrame();
      }
    },
    clearDocFrame() {
      this.vesselDoc = null;
      document.getElementById("doc-frame").src = "";
    },
    clearDocFile() {
      document.getElementById("doc-file").value = "";
    },
    isFound(id) {
        return Object.values(this.vesselEcdis).filter(value => value === id).length
    }
  },

  created() {
    this.initializeData();
  },

  computed: {
    ...mapGetters([
      "vesselInfo",
      "vesselTypeKeys",
      "vesselGroupKeys",
      "portKeys",
      "countryKeys",
      "manningKeys",
      "ecdisKeys",
    ]),
    ...mapState({
      vesselDocParticular: (state) => {
        return state.VesselParticularDocModule.vesselParticularDoc;
      },
    }),
  },
};
</script>

<style scoped>
.vessel-pic {
  width: 250px;
  height: auto;
}
</style>
